export default __webpack_public_path__ + "static/media/dp.053736cc.png";